import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import ProviderIcon from 'components/ProviderIcon';
import SVG from 'components/SVG';

import upSVG from 'features/reports/img/up.svg';
import downSVG from 'features/reports/img/down.svg';

import convertToAmericanFormat from 'shared/helpers/convertToAmericanFormat';

import './TableRow.scss';

const b = block('table-providers-row');

const TableRow = ({ item }) => {
  const { providersDiff } = useSelector(state => state.reports.statisticProvider);

  return (
    <div className={b('tr')}>
      {Object.values(item)?.map((el, index) => {
        const isBetAmount = index === 1;
        const isIncomeAmount = index === 4;

        const diff = Object.values(providersDiff ?? {})?.find(providerItem => providerItem.provider === item.provider);

        const definePercent = isBetAmount ? diff?.betCountPercent : diff?.incomeAmountPercent;
        const definePrevValue = isBetAmount ? diff?.betCount : diff?.incomeAmount;

        return (
          <div key={`${el}_${index}`} className={b('td')}>
            {index === 0 && <ProviderIcon className={b('item-icon')} name={el.toLowerCase()} />}
            <div className={b('item-container')}>
              {index !== 0 ? convertToAmericanFormat(el) : el}
              {(isBetAmount || isIncomeAmount) && diff && (
                <div className={b('item-diff')}>
                  {definePrevValue === '0' ? (
                    <p className={b('item-diff-value')}>{definePrevValue}</p>
                  ) : (
                    <>
                      <SVG className={b('item-diff-icon')} svgProps={{ svg: definePercent > 0 ? upSVG : downSVG }} />
                      <p className={b('item-diff-percent', { green: definePercent > 0 })}>{`${definePercent}%`}</p>
                      <p className={b('item-diff-value')}>{definePrevValue}</p>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

TableRow.propTypes = {
  items: PropTypes.array.isRequired,
};

export default TableRow;
